import React, { Component } from 'react';
import type { ICellRendererParams } from '@ag-grid-community/core';
import Button from '@material-ui/core/Button';
import { ButtonProps } from '@material-ui/core/Button';

export interface ButtonRendererProps extends ICellRendererParams {
  onClick: () => void;
  label?: string;
  icon?: JSX.Element;
  extraButtonProps?: ButtonProps;
}

export default class ButtonRenderer extends Component<ButtonRendererProps> {
  handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    this.props.onClick();
  };

  render() {
    const { icon, label, extraButtonProps } = this.props;

    return (
      <span>
        <Button {...extraButtonProps} onClick={this.handleClick}>
          {label ? label : null}
          {icon ? icon : null}
        </Button>
      </span>
    );
  }
}
